module.exports = __webpack_public_path__ + "img/commandcenter_stopped.0a394754.svg";